// extracted by mini-css-extract-plugin
export default {"input":"_input_jYeCNG","dropdown":"_dropdown_akq3Lt","center-aligned":"_center-aligned_OBZ0NH"};